import { filtersFromSearch, type TagMappingFilters } from './filters'
import { MATCHED_SORT_KEYS, PENDING_SORT_KEYS, type TagMappingSort } from './sort'

export type TabKey = 'matched' | 'pending'
export interface TagMappingView {
  tab: TabKey
  search: string
  filters: TagMappingFilters
  sorts: Record<TabKey, TagMappingSort | null>
}

export const readView = (params: URLSearchParams): TagMappingView => {
  const readSort = (tab: TabKey): TagMappingSort | null => {
    const key = params.get(`${tab}Sort`)
    const direction = params.get(`${tab}Direction`)
    const keys = tab === 'matched' ? MATCHED_SORT_KEYS : PENDING_SORT_KEYS
    return keys.some((allowed) => allowed === key) &&
      (direction === 'asc' || direction === 'desc')
      ? { key: key!, direction }
      : null
  }
  return {
    tab: params.get('tab') === 'pending' ? 'pending' : 'matched',
    search: params.get('q') || '',
    filters: filtersFromSearch(params),
    sorts: { matched: readSort('matched'), pending: readSort('pending') },
  }
}

/** Preserve unrelated parameters, including the organization identity. */
export const writeView = (previous: URLSearchParams, view: TagMappingView): URLSearchParams => {
  const params = new URLSearchParams(previous)
  const set = (key: string, value: string) => {
    if (value) params.set(key, value)
    else params.delete(key)
  }
  set('tab', view.tab === 'matched' ? '' : view.tab)
  set('q', view.search)
  set('board', view.filters.boardId)
  set('document', view.filters.documentId)
  set('method', view.filters.method)
  set('confidence', view.filters.confidence)
  set('source', view.filters.source)
  set('sourceType', view.filters.sourceType)
  for (const tab of ['matched', 'pending'] as const) {
    set(`${tab}Sort`, view.sorts[tab]?.key || '')
    set(`${tab}Direction`, view.sorts[tab]?.direction || '')
  }
  return params
}
